//@flow
import Cookies from 'js-cookie';

class StoredSession {
    clientId: string | void;

    constructor() {
        this.refresh();
    }

    delete() {
        Cookies.remove('clientId');
        this.deleteSessionExpiryTime();
        this.refresh();
    }

    getExpiryTime(): Date {
        // sets Cookie expiration to 12 months
        const expires = new Date();
        expires.setDate(expires.getDate() + 365);
        return expires;
    }

    setClientId(clientId: string) {
        const expires = this.getExpiryTime();
        Cookies.set('clientId', clientId, { expires });
        this.refresh();
    }

    setSessionExpiryTime(time: number) {
        localStorage.setItem('session-expiry', time.toString());
    }

    deleteSessionExpiryTime() {
        localStorage.removeItem('session-expiry');
    }

    getSessionExpiryTime(): ?number {
        const value = localStorage.getItem('session-expiry');
        return value ? parseInt(value, 10) : null;
    }

    isSessionExpired(): boolean {
        const expiry = this.getSessionExpiryTime();
        const current = Date.now();
        return typeof expiry === 'number' ? current > expiry : false;
    }

    getSessionTimeDiffFromExpiry(): ?number {
        const expiry = this.getSessionExpiryTime();
        const current = Date.now();
        return typeof expiry === 'number' ? current - expiry : null;
    }

    deleteClientId() {
        Cookies.remove('clientId');
        this.refresh();
    }

    /**
     * store session in cookie
     */
    set({ clientId }: { clientId: string }) {
        this.setClientId(clientId);
    }

    /**
     * load session from cookie
     */
    refresh() {
        this.clientId = Cookies.get('clientId');
    }
}

// creating singleton object here
const storedSession: StoredSession = new StoredSession();

export { storedSession };
export default storedSession;
